import React from 'react';
import { Trash2 } from 'lucide-react';
import TableActionButton from '../../../../components/ui/TableActionButton';

export const HardwareSelectionTable = ({ items, onRemove }) => {
  const displayItems = items ? items.filter(i => i.name && i.name.trim() !== '') : [];
  if (displayItems.length === 0) return null;

  return (
    <div className="w-full overflow-x-auto custom-scrollbar mt-2 border border-slate-200 rounded-lg shadow-sm bg-white">
      <table className="w-full text-left border-collapse whitespace-nowrap min-w-[2000px]">
        <thead>
          <tr className="bg-slate-50 border-b border-slate-200 text-[13px] font-bold text-slate-500 uppercase tracking-wider">
            <th className="px-3 py-2 border-r border-slate-200">Description</th>
            <th className="px-3 py-2 border-r border-slate-200">Article ID</th>
            <th className="px-3 py-2 border-r border-slate-200">Vendor Name</th>
            <th className="px-3 py-2 border-r border-slate-200">Category</th>
            <th className="px-3 py-2 border-r border-slate-200">Sub Category</th>
            <th className="px-3 py-2 border-r border-slate-200">Information</th>
            <th className="px-3 py-2 border-r border-slate-200">Internal Type</th>
            <th className="px-3 py-2 border-r border-slate-200">Shutter Type</th>
            <th className="px-3 py-2 border-r border-slate-200">Width</th>
            <th className="px-3 py-2 border-r border-slate-200">Height</th>
            <th className="px-3 py-2 border-r border-slate-200">Depth</th>
            <th className="px-3 py-2 border-r border-slate-200">UOM</th>
            <th className="px-3 py-2 border-r border-slate-200">MOQ</th>
            <th className="px-3 py-2 border-r border-slate-200">Purchased Qty</th>
            <th className="px-3 py-2 border-r border-slate-200 text-indigo-600">Available Qty</th>
            <th className="px-3 py-2 border-r border-slate-200">Purchase Amount</th>
            <th className="px-3 py-2 border-r border-slate-200">Verve Price</th>
            <th className="px-3 py-2 border-r border-slate-200">Taxable Amount</th>
            <th className="px-3 py-2 border-r border-slate-200">GST %</th>
            <th className="px-3 py-2 border-r border-slate-200">GST Amount</th>
            <th className="px-3 py-2 border-r border-slate-200">Invoice Number</th>
            <th className="px-3 py-2 border-r border-slate-200">Remarks</th>
            <th className="px-3 py-2 border-r border-slate-200">Date</th>
            <th className="px-3 py-2 border-r border-slate-200">Version</th>
            <th className="px-3 py-2 border-r border-slate-200">Image</th>
            <th className="px-3 py-2 border-r border-slate-200 font-black text-slate-700">Net Amount</th>
            <th className="px-3 py-2 sticky right-0 bg-slate-50 z-10 border-l border-slate-200 w-10 text-center">Action</th>
          </tr>
        </thead>
        <tbody className="text-[13px] font-medium text-slate-700">
          {displayItems.map((item, idx) => {
            const rawData = item.rawData || {}; // the full object selected from the dropdown
            const fmt = (v) => new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR' }).format(v || 0);
            
            const vendor = rawData.vendorName || (rawData.vendor?.name) || (rawData.supplier?.name) || rawData.vendor || rawData.supplier || '—';
            
            return (
              <tr key={item.tempId || idx} className="border-b border-slate-100 hover:bg-slate-50 transition-colors">
                <td className="px-3 py-2 border-r border-slate-100 max-w-[200px] truncate" title={rawData.description || rawData.itemName || item.name || '—'}>
                  {rawData.description || rawData.itemName || item.name || '—'}
                </td>
                <td className="px-3 py-2 border-r border-slate-100">{rawData.articleId || rawData.itemCode || '—'}</td>
                <td className="px-3 py-2 border-r border-slate-100">{vendor}</td>
                <td className="px-3 py-2 border-r border-slate-100">{rawData.category || '—'}</td>
                <td className="px-3 py-2 border-r border-slate-100">{rawData.subCategory || '—'}</td>
                <td className="px-3 py-2 border-r border-slate-100 max-w-[150px] truncate" title={rawData.information || '—'}>{rawData.information || '—'}</td>
                <td className="px-3 py-2 border-r border-slate-100">{rawData.internalType || '—'}</td>
                <td className="px-3 py-2 border-r border-slate-100">{rawData.shutterType || '—'}</td>
                <td className="px-3 py-2 border-r border-slate-100">{rawData.width || '—'}</td>
                <td className="px-3 py-2 border-r border-slate-100">{rawData.height || '—'}</td>
                <td className="px-3 py-2 border-r border-slate-100">{rawData.depth || '—'}</td>
                <td className="px-3 py-2 border-r border-slate-100 uppercase">{rawData.uom || '—'}</td>
                <td className="px-3 py-2 border-r border-slate-100">{rawData.moq || '—'}</td>
                <td className="px-3 py-2 border-r border-slate-100">{rawData.purchasedQty || '—'}</td>
                <td className="px-3 py-2 border-r border-slate-100 font-bold text-indigo-600">{Number(rawData.availableQty ?? rawData.stock ?? rawData.quantity ?? 0)}</td>
                <td className="px-3 py-2 border-r border-slate-100">{rawData.purchaseRate ? fmt(rawData.purchaseRate) : '—'}</td>
                <td className="px-3 py-2 border-r border-slate-100 font-bold">{rawData.vervePrice ? fmt(rawData.vervePrice) : (item.amount ? fmt(item.amount) : '—')}</td>
                <td className="px-3 py-2 border-r border-slate-100">{rawData.taxableAmount ? fmt(rawData.taxableAmount) : '—'}</td>
                <td className="px-3 py-2 border-r border-slate-100">{rawData.gstPercentage ? `${rawData.gstPercentage}%` : '—'}</td>
                <td className="px-3 py-2 border-r border-slate-100">{rawData.gstAmount ? fmt(rawData.gstAmount) : '—'}</td>
                <td className="px-3 py-2 border-r border-slate-100">{rawData.invoiceNumber || '—'}</td>
                <td className="px-3 py-2 border-r border-slate-100 max-w-[150px] truncate" title={rawData.remark || rawData.remarks || '—'}>{rawData.remark || rawData.remarks || '—'}</td>
                <td className="px-3 py-2 border-r border-slate-100">{rawData.date ? new Date(rawData.date).toLocaleDateString() : '—'}</td>
                <td className="px-3 py-2 border-r border-slate-100">{rawData.version || '—'}</td>
                <td className="px-3 py-2 border-r border-slate-100 text-center">
                  {rawData.imageUrl ? (
                    <img src={rawData.imageUrl} alt="Item" className="w-6 h-6 object-cover rounded shadow-sm mx-auto" />
                  ) : (
                    <span className="text-slate-300 text-[10px]">—</span>
                  )}
                </td>
                <td className="px-3 py-2 border-r border-slate-100 font-black text-slate-800">{rawData.netAmount ? fmt(rawData.netAmount) : (item.amount ? fmt(item.amount) : '—')}</td>
                <td className="px-3 py-2 sticky right-0 bg-white z-10 border-l border-slate-100 text-center">
                  <div className="flex justify-center scale-75">
                    <TableActionButton 
                      icon={Trash2} 
                      variant="danger" 
                      onClick={() => onRemove(item.tempId)} 
                      title="Remove Item"
                    />
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};
